import random from 'lodash/random';

export const generateId = (rounds: number = 35): string => {
  let str = '';
  for (let i = 0; i < rounds; i++) {
    str += random(33, 126).toString(16);
  }
  return str;
};
